import { render, staticRenderFns } from "./uploadHistory.vue?vue&type=template&id=2d925c0b&"
import script from "./uploadHistory.vue?vue&type=script&lang=js&"
export * from "./uploadHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports